module.exports = __webpack_public_path__ + "img/bg_login.4d981129.png";